import { createTypes } from '@u';

export default createTypes(
  'REQUEST_START',
  'REQUEST_SUCCESS',
  'REQUEST_ERROR',
  'APPLY_SERVICE',
  'GET_CURRENT_NOT',
  'SET_CURRENT_NOT'
);
